import { Text } from "@clipboard-health/ui-components";
import { Stack } from "@mui/material";

import { ANIMATION_TIMINGS } from "../constants";
import { type ScoreChange } from "../types";

interface ScoreLineItemProps extends ScoreChange {
  /**
   * Whether the line item is visible (controls opacity)
   */
  isVisible: boolean;
}

function formatValue(value: number): string {
  return value >= 0 ? `+${value}` : `${value}`;
}

function getValueColor(
  color: ScoreChange["color"]
): (theme: {
  palette: { success: { main: string }; error: { main: string }; text: { primary: string } };
}) => string {
  return (theme) => {
    if (color === "positive") {
      return theme.palette.success.main;
    }

    if (color === "negative") {
      return theme.palette.error.main;
    }

    return theme.palette.text.primary;
  };
}

export function ScoreLineItem(props: ScoreLineItemProps) {
  const { label, value, color = "default", isVisible } = props;

  return (
    <Stack
      direction="row"
      justifyContent="space-between"
      alignItems="center"
      sx={{
        opacity: isVisible ? 1 : 0,
        transition: `opacity ${ANIMATION_TIMINGS.LINE_ITEM_TRANSITION_MS}ms ease-in-out`,
      }}
    >
      <Text variant="body2" sx={(theme) => ({ color: theme.palette.text.secondary })}>
        {label}
      </Text>
      <Text semibold variant="body2" sx={(theme) => ({ color: getValueColor(color)(theme) })}>
        {formatValue(value)}
      </Text>
    </Stack>
  );
}
